import { useTranslation } from "react-i18next"
import { ErrorView } from "./ErrorView"

export const GenericErrorView = () => {
	const { t } = useTranslation("components")
	return (
		<ErrorView
			title={t("genericErrorView.title")}
			description={t("genericErrorView.description")}
		/>
	)
}
